import {
  CustomFetchClient
} from "./chunk-NFLWKIRZ.js";
import {
  panic
} from "./chunk-KKRZEVOT.js";
import {
  SEARCH_API_ENV_URL_MAP
} from "./chunk-5IRT6RWL.js";

// generated/search-api/custom-instance.ts
var customInstance = async (config, apiConfig) => {
  if (!apiConfig?.applicationKey) {
    panic("x-application-key is required");
  }
  return new CustomFetchClient({
    defaultBaseURL: SEARCH_API_ENV_URL_MAP[apiConfig?.environment ?? "prod"]
  }).request(config, apiConfig);
};

// generated/search-api/controllers/eVSearchV3API.ts
var listingRequestAccess = (listingID, inputAccessRequest, options) => {
  return customInstance(
    {
      url: `/api/listing/${listingID}/access`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: inputAccessRequest
    },
    options
  );
};
var listingLead = (listingID, inputContact, options) => {
  return customInstance(
    {
      url: `/api/listing/${listingID}/lead`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: inputContact
    },
    options
  );
};

export {
  listingRequestAccess,
  listingLead
};
